export const applicationPaths = {
  dashboard: 'dashboard',
  catalog: 'catalog',
  matrix: 'catalog/matrix',
  needs: 'needs-summary',
  training_plan: 'training-plan',
  planning: 'planning',
  accreditations: 'accreditations',
}

export const defaultPath = 'catalog'

export const pagesWithDefaultVintage = ['needs-summary', 'training-plan']
